// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".system-bar[data-v-29f845ee]{padding-left:88px}.logo[data-v-29f845ee]:hover{color:hsla(0,0%,100%,.7)}.dev-clock[data-v-29f845ee]{position:fixed;bottom:50px;left:100px}[data-v-29f845ee] .v-dialog__content{align-items:start}.no-transition[data-v-29f845ee] .v-progress-circular__overlay{transition:all .1s ease-in-out}", ""]);
// Exports
module.exports = exports;
